


















































import {Component, Vue, Watch} from 'vue-property-decorator';

@Component({
  name: 'header-cart',
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el['clickOutsideEvent']);
      },
      unbind(el) {
        document.body.removeEventListener('click', el['clickOutsideEvent']);
      }
    }
  }
})

export default class extends Vue {
  private get totalSegments(): Array<object> {
    const segmentsToShow = ['subtotal'];
    return this.cartTotals ? this.cartTotals['total_segments'].filter(s => segmentsToShow.includes(s.code)) : [];
  }

  private get cartTotals(): object {
    return this.$store.getters['CheckoutCart/cartTotals'];
  }

  private get quoteItemCount(): number {
    return this.$store.state.CheckoutGlobal.quoteItemCount;
  }
  private get headerTotal(): string {
    if(!this.$store.state.CheckoutCart.cartTotals) {
      return '0,00';
    }
    return this.$store.state.CheckoutCart.cartTotals['base_grand_total'];
  }

  private get showCartPopup(): boolean {
    return this.$store.getters['CheckoutCart/showCartPopup'];
  }

  private get showProductAdded(): boolean {
    return this.$store.getters['CheckoutCart/showProductAdded'];
  }

  private closeCartPopup(): void {
    this.$store.dispatch('CheckoutCart/showCartPopup', false);
  }

  private dropdownEvent(e): void {
    if (this.quoteItemCount > 0 && window.outerWidth >= 768) {
      this.$store.dispatch('CheckoutCart/showCartPopup', e.type === 'mouseenter');
    }
  }

  private mounted(): void {
    window.addEventListener('scroll',()=>{
      setTimeout(() => {
        this.closeCartPopup();
      }, 500);
    });
  }

  @Watch('showCartPopup')
  closeShowProductAdded(newVal) {
    if (newVal) {
      const _this = this;
      setTimeout(function () {
        _this.closeCartPopup();
      }, 5000);
    }
  }
}
